import type { CustomCellRendererProps } from "ag-grid-react";

import { ApplicationStatusBadge } from "../../../components/application/application-status";
import { useClientType } from "../../../shared/hooks/use-client-type";
import type { ApplicationsTableItem } from "../applications-page.lib";
import { APPLICATION_STATUS_FALLBACK_LABEL, type ApplicationStatus } from "../applications-page.status";

export const ApplicationStatusCell = ({ data }: CustomCellRendererProps<ApplicationsTableItem>) => {
  const clientType = useClientType();
  const applicationStatus = data?.status as ApplicationStatus | undefined;
  const displayStatus = (data as { displayStatus?: string } | undefined)?.displayStatus;

  if (!applicationStatus) {
    return <span className="text-type-minor">—</span>;
  }

  return (
    <ApplicationStatusBadge
      contour={clientType ?? "internal"}
      label={displayStatus ?? APPLICATION_STATUS_FALLBACK_LABEL[applicationStatus]}
      status={applicationStatus}
    />
  );
};
